import "next-auth";
import { z } from "zod";

declare module "next-auth" {
    // eslint-disable-next-line no-unused-vars
    interface Session {
        user: {
            userID: number;
            name: string;
            email: string;
            role: UserRoles;
            powerUser: boolean;
            states: string[];
            customerIDs: number[];
            supplierIDs: number[];
            profilePictureURL?: string;
            tcAcceptedDict: TCAcceptedDict;
        };

        currentCustomerID: number | null;
        defaultStateCode: string | null;
    }
}

export type TCAcceptedDict = { [key: string]: boolean };

export type UserRoles = "Admin" | "DistributorRep" | "Customer" | "Supplier";

export type AccessRequestFormData = {
    companyName: string;
    bccLicenseNumber: string;
    kssInvoiceNumber?: string;
    email: string;
    firstName: string;
    lastName: string;
    title: string;
    phone: string;
};

export const signupSchema = z.object({
    companyName: z.string().min(1, "Company name is required"),
    bccLicenseNumber: z.string().min(1, "BCC License number is required"),
    kssInvoiceNumber: z.string().optional(),
    email: z.string().email("Invalid email address"),
    firstName: z.string().min(1, "First name is required"),
    lastName: z.string().min(1, "Last name is required"),
    title: z.string(),
    phone: z.string().min(10, "Valid phone number is required")
});
